import React, { ComponentProps, VFC } from 'react';

import { MovieAudioSettingPopupButtonContainer } from '../../feature-player/ui/movie/movie-audio-setting-popup-button/container';
import { useAudio } from '../hooks/use-audio';
import { useSubtitles } from '../hooks/use-subtitles';

type Props = Omit<ComponentProps<typeof MovieAudioSettingPopupButtonContainer>, 'subtitles'>;

export const FilmAudioSettingsPopupButtonContainer: VFC<Props> = ({ contentId, ...props }) => {
    const { subtitles, forceSubtitle } = useSubtitles(contentId);
    const audioTracks = useAudio(contentId);

    return (
        <MovieAudioSettingPopupButtonContainer
            contentId={contentId}
            audioTracks={audioTracks}
            subtitles={subtitles || []}
            forceSubtitle={forceSubtitle}
            {...props}
        />
    );
};
